var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.37259 20.4364C8.37259 19.1092 8.59292 17.836 8.98655 16.6429L2.09883 11.3828C0.712891 14.1993 -0.00529458 17.2974 2.93852e-05 20.4364C2.93852e-05 23.6908 0.755946 26.7589 2.09622 29.483L8.98046 24.2142C8.57861 22.9952 8.37342 21.72 8.37259 20.4364",
    fill: "#FBBC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4682 8.36047C23.3517 8.36047 25.9565 9.38287 28.003 11.0549L33.9563 5.10951C30.3282 1.95085 25.6769 0.000102711 20.4682 0.000102711C16.6482 -0.0120159 12.9014 1.04848 9.65441 3.0609C6.40739 5.07331 3.7905 7.95682 2.10156 11.3833L8.98841 16.6433C9.78489 14.2291 11.3238 12.1284 13.3855 10.641C15.4472 9.15366 17.9261 8.35578 20.4682 8.36134",
    fill: "#EB4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4613 32.5164C17.9191 32.5219 15.4402 31.724 13.3786 30.2367C11.3169 28.7493 9.77795 26.6486 8.98147 24.2344L2.09375 29.4927C3.78256 32.9193 6.3994 35.803 9.64643 37.8156C12.8935 39.8281 16.6403 40.8888 20.4604 40.8767C25.4523 40.8767 30.2185 39.1036 33.7952 35.783L27.2576 30.7285C25.4131 31.8911 23.0896 32.5164 20.4613 32.5164",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0033 20.4348C40.0033 19.2269 39.8178 17.9266 39.5382 16.7188H20.4688V24.6149H31.4452C30.8966 27.3068 29.4021 29.3769 27.265 30.7232L33.8027 35.7778C37.5596 32.2908 40.0033 27.0961 40.0033 20.4348",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.29d5a3cbf91122728427270a2e52127f.svg";
export { ForwardRef as ReactComponent };